import { useQuery } from '@apollo/client/react';

import { listQuery } from '../../services/PaymentService';

export const usePayments = (filter, { limit, offset }) => {
  const { data, loading, error } = useQuery(listQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { filter, limit, offset }
  });

  return { payments: data?.payments || [], loading, error };
};
